import { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Marina Costa",
    role: "Fundadora, Studio Cromo",
    avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&q=80",
    text: "Em três semanas tinham reposicionado a nossa presença digital. O site novo trouxe 3x mais leads qualificados no primeiro mês.",
  },
  {
    name: "Rafael Mendes",
    role: "CTO, NeoBank",
    avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&q=80",
    text: "A entrega técnica foi impecável. Time sênior, comunicação direta e zero retrabalho. Voltaremos com certeza.",
  },
  {
    name: "Júlia Tavares",
    role: "Marketing, Casa Tomate",
    avatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&q=80",
    text: "A BezierClick entendeu o nosso público B2B melhor do que nós. Visual forte, e-commerce rápido e uma jornada que realmente vende.",
  },
];

const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = testimonials[i];
  const prev = () => setI((p) => (p - 1 + testimonials.length) % testimonials.length);
  const next = () => setI((p) => (p + 1) % testimonials.length);

  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="bg-[#ff6b35] noise py-24 md:py-32 relative overflow-hidden"
    >
      <div className="absolute inset-0 dot-pattern opacity-10 pointer-events-none" />

      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 relative">
        <div className="text-center mb-12 vc-reveal">
          <div className="inline-block bg-[#0a0a0a] text-white px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-4">
            ✦ Quem confia
          </div>
          <h2 className="font-display text-[#0a0a0a] text-5xl sm:text-7xl uppercase leading-[0.9]">
            Empresas <br />
            <span className="text-outline">crescem online.</span>
          </h2>
        </div>

        <div className="bg-[#0a0a0a] border-[6px] border-white brutal-shadow p-8 sm:p-12 relative">
          <Quote size={68} className="text-[#ff6b35] absolute -top-8 left-8" strokeWidth={2.5} />

          <p
            data-testid="testimonial-text"
            className="text-white text-xl sm:text-2xl leading-snug font-medium mt-4"
          >
            "{t.text}"
          </p>

          <div className="mt-8 flex items-center justify-between flex-wrap gap-6">
            <div className="flex items-center gap-4">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-16 h-16 rounded-full border-4 border-white object-cover"
              />
              <div>
                <div className="font-display text-[#ff6b35] text-xl uppercase" data-testid="testimonial-name">
                  {t.name}
                </div>
                <div className="font-mono text-xs uppercase text-white tracking-widest">
                  {t.role}
                </div>
              </div>
            </div>

            <div className="flex items-center gap-3">
              <button
                data-testid="testimonial-prev"
                onClick={prev}
                aria-label="Anterior"
                className="bg-white text-[#0a0a0a] brutal-border p-3 hover:bg-[#ff6b35] transition-colors"
              >
                <ChevronLeft size={22} />
              </button>
              <button
                data-testid="testimonial-next"
                onClick={next}
                aria-label="Próximo"
                className="bg-white text-[#0a0a0a] brutal-border p-3 hover:bg-[#ff6b35] transition-colors"
              >
                <ChevronRight size={22} />
              </button>
            </div>
          </div>

          <div className="mt-6 flex gap-2">
            {testimonials.map((_, idx) => (
              <span
                key={idx}
                className={`h-1 transition-all ${
                  idx === i ? "w-12 bg-[#ff6b35]" : "w-6 bg-white/40"
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
